// extracted by mini-css-extract-plugin
module.exports = {"ionContent":"style_ionContent__sNhpb"};